import { useMemo, useState } from "react";

/**
 * Remembers the column set the user confirmed a large (paginated) load for.
 * Compared during render, so the data query never starts before Confirm.
 * Keyed on the sorted set: reordering columns keeps the confirmation, while
 * adding or removing columns asks again.
 */
const useLargeLoadConfirmation = (selectedProperties: Maybe<string[]>) => {
  const [confirmedColumnsKey, setConfirmedColumnsKey] = useState<Nullable<string>>(null);
  const columnsKey = useMemo(
    () => JSON.stringify([...(selectedProperties ?? [])].sort()),
    [selectedProperties]
  );

  return {
    largeLoadConfirmed: confirmedColumnsKey === columnsKey,
    confirmLargeLoad: () => setConfirmedColumnsKey(columnsKey)
  };
};

export default useLargeLoadConfirmation;
